module.exports = __webpack_public_path__ + "img/ultimateq-logo-2.08ade221.png";